// src/views/components/ExperienceShimmer.js
import React from 'react';
import SectionWrapper from './SectionWrapper';
import { useLanguage } from '../../i18n/LanguageContext';


export default function ExperienceShimmer({ count = 3 }) {
  const { t } = useLanguage();

  return (
    <SectionWrapper id="experience">
      <h2 className="section-title mb-4">{t('experience.title')}</h2>
      {Array.from({ length: count }).map((_, idx) => (
        <div key={idx} className="experience-shimmer-card mb-4">
          <div className="d-flex align-items-center mb-3">
            <div className="shimmer-logo me-3" />
            <div>
              <div className="shimmer-line short mb-2" />
              <div className="shimmer-line medium" />
            </div>
          </div>
          <ul className="list-unstyled mt-3">
            {Array.from({ length: 4 }).map((__, i) => (
              <li key={i} className="mb-2">
                <div className="shimmer-line bullet" />
              </li>
            ))}
          </ul>
        </div>
      ))}
    </SectionWrapper>
  );
}
